import IconPie from './IconPie'
import { IconProps } from '@tabler/icons-react-native'

interface Props extends IconProps {
  target: number
  total: number
}

export default function IconPercentage({ target, total, ...props }: Props) {
  const percentage = Math.round((target / total) * 100)

  return <IconPie value={percentage} {...props} />
}
